
import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from './badge';

interface SectionHeaderProps {
  badge?: string;
  title: string;
  description?: string;
  className?: string;
  centered?: boolean;
  titleClassName?: string;
  descriptionClassName?: string;
  badgeClassName?: string;
  badgeBgClassName?: string;
  titleGradient?: boolean;
}

const SectionHeader = ({ 
  badge, 
  title, 
  description, 
  className, 
  centered = true,
  titleClassName,
  descriptionClassName,
  badgeClassName,
  badgeBgClassName = "bg-accent/20",
  titleGradient = false
}: SectionHeaderProps) => {
  return (
    <div className={cn(
      "mb-16", 
      centered && "text-center",
      className
    )}>
      {badge && (
        <div className={cn(
          "inline-flex items-center px-3 py-1 rounded-full mb-4",
          badgeBgClassName
        )}>
          <span className={cn("text-sm font-medium", badgeClassName)}>{badge}</span>
        </div>
      )}
      <h2 className={cn(
        "text-3xl md:text-4xl font-bold mb-4",
        titleGradient && "text-gradient",
        titleClassName
      )}>
        {title}
      </h2>
      {description && (
        <p className={cn(
          "text-lg text-foreground/80 max-w-3xl",
          centered && "mx-auto",
          descriptionClassName
        )}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
